import "./Jobs.scss";

import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";

import AttachFileIcon from "@mui/icons-material/AttachFile";
import CardHistory from "../topicStartegyBuilder/CardHistory";
import CustomToast from "../../utils/cutomToast/CustomToast";
import Loader from "../../utils/loader/Loader";
import axios from "axios";
import { urlConstants } from "../../components/constants/globalConstants";

const Jobs = () => {
  const [jobDetails, setJobDetails] = useState<any>({
    jobName: "",
    businessObjective: "",
    offers: "",
    csvFile: null,
  });
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [loading, setLoading] = useState(false);
  const cardHistoryRef = useRef<any>(null);

  const handleCsvUpload = (event: any) => {
    setJobDetails({
      ...jobDetails,
      csvFile: event.target.files[0],
    });
  };

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const validateJobDetails = () => {
    const { jobName, businessObjective, offers, csvFile } = jobDetails;
    if (!jobName || !businessObjective || !offers || !csvFile) {
      CustomToast("Please fill in all required fields.", "error");
      return false;
    }
    return true;
  };
  console.log(jobDetails,'====')
  const handleJobCreation = async () => {
    if (!validateJobDetails()) return;
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("business_id", "");
      formData.append("csv_file", jobDetails.csvFile);
      formData.append("name", jobDetails.jobName);
      formData.append("serve", jobDetails.businessObjective.toLowerCase());
      formData.append("sell", jobDetails.offers.toLowerCase());
      
      let response = await axios.post(
        `${urlConstants.PROMPT_URL}/job`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      let finalRes = response.data;
    
      if (finalRes) {
        CustomToast(
          `Job "${jobDetails.jobName}" created successfully`,
          "success"
        );
        setJobDetails({
          jobName: "",
          businessObjective: "",
          offers: "",
          csvFile: null,
        });
        cardHistoryRef.current?.refresh?.();
      } else {
        CustomToast("job creation failed, try again.", "error");
      }
    } catch (error: any) {
      CustomToast(error?.response?.data?.detail[0]?.msg ||  error?.response?.data?.detail || error?.message, "error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box className="jobs-main-container">
      <Box className="jobs-container">
        <Box className="jobs-title">
          <Typography variant="h4" sx={{ color: "rgba(0, 0, 0, 0.87)" }}>
            Jobs
          </Typography>
        </Box>
      </Box>
      <Divider
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          alignSelf: "stretch",
        }}
      />
      <Loader spinning={loading}>
        <Box className="jobs-body-container">
          <Box className="body-left">
            <Box className="jobname-container">
              <Box className="inner-container">
                <Box className="text-container">
                  <Box className="text-group">
                    <Typography variant="subtitle2">
                      <span style={{ color: "#CD3535" }}>*</span>
                      <span style={{ color: "#171D1A)" }}>Job Name</span>{" "}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(0, 0, 0, 0.38)" }}
                    >
                      Give this function a name
                    </Typography>
                  </Box>
                </Box>
                <TextField
                  id="website"
                  label=""
                  placeholder="type something here"
                  value={jobDetails.jobName}
                  onChange={(e) =>
                    setJobDetails({
                      ...jobDetails,
                      jobName: e.target.value,
                    })
                  }
                  variant="outlined"
                  size="small"
                  sx={{ width: 464, height: 40 }}
                />
              </Box>
            </Box>
            <Box className="place-container">
              <Box className="inner-container">
                <Box className="text-container">
                  <Box className="text-group">
                    <Typography variant="subtitle2">
                      <span style={{ color: "#CD3535" }}>*</span>
                      <span style={{ color: "#171D1A)" }}>
                        Where does the business primarily serve its customers?
                      </span>{" "}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(0, 0, 0, 0.38)" }}
                    >
                      Indicate if you serve your customers at a physical
                      location or online
                    </Typography>
                  </Box>
                </Box>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={jobDetails.businessObjective}
                  onChange={(e) => {
                    setJobDetails({
                      ...jobDetails,
                      businessObjective: e.target.value,
                    });
                  }}
                >
                  {["Local", "Online"].map((step, index) => (
                    <FormControlLabel
                      key={index}
                      value={step}
                      control={<Radio />}
                      label={step}
                    />
                  ))}
                </RadioGroup>
              </Box>
            </Box>
            <Box className="offers-container">
              <Box className="inner-container">
                <Box className="text-container">
                  <Box className="text-group">
                    <Typography variant="subtitle2">
                      <span style={{ color: "#CD3535" }}>*</span>
                      <span style={{ color: "#171D1A)" }}>
                        What type of offerings does the business serve its
                        customers?
                      </span>{" "}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(0, 0, 0, 0.38)" }}
                    >
                      Indicate whether your business primarily serves its
                      customers at a physical location or online
                    </Typography>
                  </Box>
                </Box>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={jobDetails.offers}
                  onChange={(e) => {
                    setJobDetails({
                      ...jobDetails,
                      offers: e.target.value,
                    });
                  }}
                >
                  {["Products", "Services", "Both"].map((step, index) => (
                    <FormControlLabel
                      key={index}
                      value={step}
                      control={<Radio />}
                      label={step}
                    />
                  ))}
                </RadioGroup>
              </Box>
            </Box>
            <Box
              className="csv-job-container"
              sx={{ height: "154px !important", marginTop: "24px !important" }}
            >
              <Box
                className="inner-container"
                sx={{ height: "154px !important" }}
              >
                <Box className="text-container">
                  <Box className="text-group">
                    <Typography variant="subtitle2">
                      <span style={{ color: "#CD3535" }}>*</span>
                      <span style={{ color: "#171D1A)" }}>
                        What are the offerings?
                      </span>{" "}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(0, 0, 0, 0.38)" }}
                    >
                      Upload all the business's offerings
                    </Typography>
                  </Box>
                </Box>
                <TextField
                  id="upload-csv"
                  label="Upload CSV"
                  value={jobDetails.csvFile ? jobDetails.csvFile.name : ""}
                  variant="filled"
                  size="medium"
                  sx={{ width: 440, height: 24 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <AttachFileIcon
                          style={{ cursor: "pointer" }}
                          onClick={handleIconClick}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
                <input
                  type="file"
                  accept=".csv"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleCsvUpload}
                />
              </Box>
            </Box>
            <Button
              size="large"
              variant="contained"
              color="primary"
              onClick={handleJobCreation}
              sx={{ width: 512, height: 42, marginBottom: 24 }}
            >
              Create Job
            </Button>
          </Box>
          <Box className="body-right">
            <CardHistory con={true} nav={null} ref={cardHistoryRef} />
          </Box>
        </Box>
      </Loader>
    </Box>
  );
};

export default Jobs;
